import { Dispatch, SetStateAction } from "react";
import { Col, Collapse, FormLabel, Row, RowProps } from "react-bootstrap";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";

interface CollapseRowProps extends RowProps {
  label: string | React.ReactElement;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * Collapsible row component with clickable label and chevron indicator.
 *
 * @param props - The component props
 * @param props.label - Text or element to display as the collapsible row label
 * @param props.isOpen - Whether the row is currently expanded
 * @param props.setIsOpen - Function to toggle the expanded state
 * @param props.children - Child element to display when expanded
 */
export const CollapseRow = ({ label, isOpen, setIsOpen, children, ...rest }: CollapseRowProps) => (
  <Row {...rest}>
    <Col>
      <Row className="mt-2">
        <Col>
          <FormLabel
            onClick={() => setIsOpen((prev) => !prev)}
            className="d-flex align-items-center cursor-pointer"
          >
            {typeof label === "string" ? <span className="fw-bold">{label}</span> : label}
            <span className="ms-2">{isOpen ? <ChevronDown /> : <ChevronRight />}</span>
          </FormLabel>
        </Col>
      </Row>
      <Collapse
        className="mb-2"
        in={isOpen}
      >
        <div>{children}</div>
      </Collapse>
    </Col>
  </Row>
);

CollapseRow.displayName = "CollapseRow";
